import { ANSWER_ORIGIN, UNCONVERTIBLE_PAGE_SIZE, UNCONVERTIBLE_REASONS } from './activityBatchConversion.constants';

export function isInferredActivity(activity) {
  return activity?.answer_origin === ANSWER_ORIGIN.INFERRED;
}

export function filterInferredActivities(activities = []) {
  return (Array.isArray(activities) ? activities : []).filter(isInferredActivity);
}

export function getAnswerOriginLabelKey(origin) {
  // Comparar el valor y no su verdad descarta también las claves heredadas ('constructor').
  if (!origin || ANSWER_ORIGIN[origin] !== origin) return '';

  return `activityBatches:review_origin_${origin.toLowerCase()}`;
}

// Pestañas del panel de revisión en digitalización (TAN-10243).
export const REVIEW_TAB = {
  CONVERTED: 'converted',
  UNCONVERTIBLE: 'unconvertible',
};

// `reason` es un enum del contrato y se traduce desde una clave propia; `reason_detail` es texto
// libre y nunca se usa como clave.
export function getUnconvertibleReasonLabelKey(reason) {
  const key = String(reason ?? '')
    .trim()
    .toUpperCase();

  return UNCONVERTIBLE_REASONS.includes(key) ? `activityBatches:unconvertible_reason_${key.toLowerCase()}` : 'activityBatches:unconvertible_reason_unknown';
}

const toPageSize = (limit) => (Number(limit) > 0 ? Number(limit) : UNCONVERTIBLE_PAGE_SIZE);

export function getUnconvertiblePageCount(total, limit = UNCONVERTIBLE_PAGE_SIZE) {
  return Math.max(1, Math.ceil((Number(total) || 0) / toPageSize(limit)));
}

export function getUnconvertiblePageIndex(offset, limit = UNCONVERTIBLE_PAGE_SIZE) {
  return Math.max(0, Math.floor((Number(offset) || 0) / toPageSize(limit)));
}

// Mientras el total no se haya resuelto (primera carga o fallo del GET) la pestaña no rotula cifra:
// un 0 afirmaría que el PDF se digitalizó entero, justo lo contrario de un dato desconocido.
export function getUnconvertibleTabLabel({ hasLoaded, total = 0 } = {}) {
  if (!hasLoaded) return { key: 'activityBatches:review_tab_unconvertible_unknown' };

  return { key: 'activityBatches:review_tab_unconvertible', params: { count: total } };
}

// Texto de la única región live del panel de revisión: se compone aquí porque la región vive por
// encima de las pestañas (montarla junto a su contenido no se anuncia de forma fiable). Devuelve
// partes {key, params} que el consumidor traduce y une.
export function getUnconvertibleAnnouncement({ error, limit = UNCONVERTIBLE_PAGE_SIZE, loading, offset = 0, total = 0 } = {}) {
  if (loading) return [{ key: 'activityBatches:unconvertible_loading' }];
  if (error) return [{ key: 'activityBatches:unconvertible_error' }];
  // Fuera de rango la lista no tiene ítems que anunciar: sin esta rama el texto afirmaría una
  // página que en pantalla está vacía.
  if (Number(total) > 0 && Number(offset) >= Number(total)) return [{ key: 'activityBatches:unconvertible_page_empty' }];

  const pageCount = getUnconvertiblePageCount(total, limit);
  const parts = [{ key: 'activityBatches:unconvertible_count', params: { count: total } }];
  if (pageCount > 1) {
    parts.push({ key: 'activityBatches:unconvertible_page_announcement', params: { page: getUnconvertiblePageIndex(offset, limit) + 1, total: pageCount } });
  }

  return parts;
}
